module.exports = __webpack_public_path__ + "static/media/PostWar-Europe.320d5521.jpg";